<div class="modal fade show custom_popup" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content width-545">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title">New Credebtor</h5>
        <ng-toggle
          [value]="isPersonEntity ? toggleSettings.values.unchecked : toggleSettings.values.checked"
          [width]="isPersonEntity ? 72 : 105"
          [height]="20"
          [labels]="toggleSettings.labels"
          [switchColor]="toggleSettings.switchColor"
          [color]="toggleSettings.color"
          [values]="toggleSettings.values"
          [fontColor]="toggleSettings.fontColor"
          (valueChange)="toggleChange($event)"
        />
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body padding-model form-editing">
        <div class="row">
          <div class="col-lg-12">
            <div class="card w-100">
              <div class="card">
                <form *ngIf="addForm" [formGroup]="addForm" (ngSubmit)="onSubmit()">
                  <div class="row">
                    <!-- Section Main Details -->
                    <ng-container>
                      <div class="width-85 field-groups">
                        <div class="mt-1">
                          <label for="type" class="form-title text-nowrap">
                            <span class="required">*</span> Type
                          </label>
                          <ng-select
                            class="custom"
                            id="roleId-2"
                            [style.flex]="1"
                            appendTo="div"
                            [items]="types"
                            [virtualScroll]="true"
                            [clearable]="false"
                            bindLabel="name"
                            bindValue="id"
                            placeholder="All"
                            formControlName="type"
                          >
                            <ng-template ng-label-tmp let-item="item">
                              {{ item.id }}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                              <span [title]="item.name" tooltip="item.name">{{ item.name }}</span>
                            </ng-template>
                          </ng-select>
                        </div>
                        <app-form-error-component [control]="addForm.controls['type']"></app-form-error-component>
                      </div>

                      <div *ngIf="!isPersonEntity" class="width-235 field-groups mt-1">
                        <div>
                          <div class="d-flex justify-content-between">
                            <label for="organisation" class="form-title"
                              ><span class="required">*</span>Organisation</label
                            >
                            <div class="d-flex">
                              <label for="previousCheck" class="form-title me-2">Previous</label>
                              <input
                                (change)="handlePreviewCheck($event)"
                                formControlName="isPrevious"
                                id="previousCheck"
                                type="checkbox"
                              />
                            </div>
                          </div>
                        </div>
                        <input
                          type="text"
                          class="form-control sd-width"
                          placeholder=""
                          formControlName="organisationName"
                          id="organisationName"
                        />
                        <app-form-error-component
                          [control]="addForm.controls['organisationName']"
                        ></app-form-error-component>
                      </div>

                      <div *ngIf="isShowPreviousInput && !isPersonEntity" class="width-175 field-groups">
                        <div class="mt-1 mb-1">
                          <label for="previousName" class="form-title text-nowrap"> Previous Name </label>
                          <input
                            type="text"
                            class="form-control sd-width"
                            placeholder=""
                            formControlName="previousName"
                            id="previousName"
                          />
                        </div>
                        <app-form-error-component
                          [control]="addForm.controls['previousName']"
                        ></app-form-error-component>
                      </div>
                      <div *ngIf="isPersonEntity" class="width-205 mt-1">
                        <div>
                          <div class="d-flex justify-content-between">
                            <label for="firstName" class="form-title"><span class="required">*</span> First Name</label>
                          </div>
                        </div>
                        <input type="text" class="form-control" formControlName="firstName" id="firstName" />
                        <app-form-error-component [control]="addForm.controls['firstName']" />
                      </div>
                      <div *ngIf="isPersonEntity" class="width-205 mt-1">
                        <div>
                          <label for="lastName" class="form-title"
                            ><span *ngIf="true" class="required">*</span> Last Name</label
                          >
                        </div>
                        <input type="text" class="form-control" formControlName="lastName" id="lastName" />
                        <app-form-error-component [control]="addForm.controls['lastName']" />
                      </div>

                      <div *ngIf="!isPersonEntity" class="width-175 field-groups">
                        <div class="mt-1">
                          <label for="tradeName" class="form-title text-nowrap"> Trading Name </label>
                          <input
                            type="text"
                            class="form-control sd-width"
                            placeholder=""
                            formControlName="tradeName"
                            id="tradeName"
                          />
                        </div>
                        <app-form-error-component [control]="addForm.controls['tradeName']"></app-form-error-component>
                      </div>

                      <div class="width-150 zIndex">
                        <div class="mt-1">
                          <label for="roleId-2" class="form-title">Classification</label>
                          <ng-select
                            class="custom"
                            id="roleId-2"
                            [style.flex]="1"
                            appendTo="div"
                            [items]="classificationList"
                            [virtualScroll]="true"
                            bindLabel="value"
                            bindValue="id"
                            placeholder="All"
                            formControlName="classificationId"
                          >
                            <ng-template ng-label-tmp let-item="item">
                              {{ item.value }}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                              <span [title]="item.value" tooltip="item.name">{{ item.value }}</span>
                            </ng-template>
                          </ng-select>
                        </div>
                        <app-form-error-component [control]="addForm.controls['classification']" />
                      </div>
                    </ng-container>

                    <!-- Section Bank Details -->
                    <ng-container>
                      <div class="card dabetors-creditor-card">
                        <div class="card-header">Bank Details</div>
                      </div>

                      <div class="width-90 field-groups">
                        <div class="mt-1">
                          <label for="currency" class="form-title text-nowrap">
                            <span class="required">*</span> Ccy
                          </label>
                          <div class="input-group">
                            <ng-select
                              class="custom"
                              id="roleId-2"
                              [style.flex]="1"
                              appendTo="div"
                              [items]="currencyList"
                              [virtualScroll]="true"
                              [clearable]="false"
                              bindLabel="name"
                              bindValue="id"
                              placeholder="All"
                              formControlName="ccy"
                            >
                              <ng-template ng-label-tmp let-item="item">
                                {{ item.id }}
                              </ng-template>
                              <ng-template ng-option-tmp let-item="item">
                                <span [title]="item.name" tooltip="item.name">{{ item.name }}</span>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <app-form-error-component [control]="addForm.controls['ccy']"></app-form-error-component>
                      </div>
                      <div class="width-175 field-groups">
                        <div class="mt-1">
                          <label for="bankId" class="form-title text-nowrap">Bank</label>
                          <div class="input-group">
                            <ng-select
                              class="custom"
                              id="roleId-2"
                              [style.flex]="1"
                              appendTo="div"
                              [items]="allBankData"
                              [virtualScroll]="true"
                              [clearable]="false"
                              bindLabel="name"
                              bindValue="id"
                              placeholder="All"
                              formControlName="bankId"
                              (change)="onBankChange($event)"
                            >
                              <ng-template ng-label-tmp let-item="item">
                                {{ item.id }}
                              </ng-template>
                              <ng-template ng-option-tmp let-item="item">
                                <span [title]="item.name" tooltip="item.name">{{ item.name }}</span>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <app-form-error-component [control]="addForm.controls['bankId']"></app-form-error-component>
                      </div>
                      <div class="width-120 field-groups accountNumber">
                        <div class="mt-1">
                          <label for="accountNumber" class="form-title text-nowrap">
                            <span class="required" *ngIf="!addForm.get('iban')?.value">*</span> Bank Account
                          </label>
                          <input
                            type="number"
                            class="form-control sd-width"
                            placeholder=""
                            appOnlyNumber
                            [allowedSign]="'none'"
                            formControlName="account"
                            id="accountNumber"
                          />
                        </div>
                        <app-form-error-component [control]="addForm.controls['account']" />
                        <div
                          *ngIf="
                            addForm.hasError('ibanOrAccountRequired') &&
                            (addForm.get('account')?.touched || addForm.get('iban')?.touched || isSubmitted)
                          "
                          class="error-msg"
                        >
                          <label class="error">
                            <img alt="" src="assets/images/icon/error.png" class="error-icon" />
                            IBAN or Bank Account is required.
                          </label>
                        </div>
                      </div>
                      <div class="width-85 field-groups">
                        <div class="mt-1">
                          <label for="sortCode" class="form-title">Sort Code</label>
                          <input
                            type="text"
                            maxlength="14"
                            class="form-control sd-width"
                            placeholder=""
                            formControlName="sortCode"
                            id="sortCode"
                          />
                        </div>
                        <app-form-error-component [control]="addForm.controls['sortCode']" />
                      </div>
                      <div class="width-90 field-groups">
                        <div class="mt-1">
                          <label for="swiftBic" class="form-title text-nowrap"> SWIFT BIC </label>

                          <input
                            type="text"
                            maxlength="8"
                            style="text-transform: uppercase"
                            class="form-control sd-width"
                            placeholder=""
                            formControlName="swiftBic"
                            id="swiftBic"
                          />
                        </div>
                        <app-form-error-component [control]="addForm.controls['swiftBic']"></app-form-error-component>
                      </div>
                      <div class="width-175 mb-1 field-groups">
                        <div class="mt-1">
                          <label for="iban" class="form-title text-nowrap">
                            <span class="required" *ngIf="!addForm.get('account')?.value">*</span> IBAN
                            <span class="tooltip-ng ms-0" placement="bottom" ngbTooltip="{{ tooltipData.iban }}">
                              <i class="bi bi-question-circle"></i>
                            </span>
                          </label>
                          <input
                            type="text"
                            maxlength="34"
                            style="text-transform: uppercase"
                            class="form-control sd-width"
                            placeholder=""
                            formControlName="iban"
                            id="iban"
                          />
                        </div>
                        <app-form-error-component [control]="addForm.controls['iban']"></app-form-error-component>
                        <div
                          *ngIf="
                            addForm.hasError('ibanOrAccountRequired') &&
                            (addForm.get('account')?.touched || addForm.get('iban')?.touched || isSubmitted)
                          "
                          class="error-msg"
                        >
                          <label class="error">
                            <img alt="" src="assets/images/icon/error.png" class="error-icon" />
                            IBAN or Bank Account is required.
                          </label>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Section Account Contact Details -->
                    <ng-container>
                      <div class="card dabetors-creditor-card">
                        <div class="card-header">Account Contact Details</div>
                      </div>

                      <ng-container formGroupName="phoneNumbers">
                        <div class="phone-container width-165 field-groups" formGroupName="mobile">
                          <div class="mt-1">
                            <label class="form-title text-nowrap">
                              <span *ngIf="showPhoneAsterisk('mobile')" class="required">*</span>Mobile Phone
                            </label>
                            <div class="d-flex flex-column">
                              <div class="d-flex align-items-center">
                                <input
                                  type="text"
                                  class="form-control width-45 me-1"
                                  appOnlyNumber
                                  [allowedSign]="'+'"
                                  [keepSignAndZero]="true"
                                  placeholder="+353"
                                  formControlName="countryCode"
                                  (input)="handleValidatePhone('mobile')"
                                />
                                <input
                                  type="text"
                                  class="form-control width-35 me-1"
                                  appOnlyNumber
                                  [keepSignAndZero]="true"
                                  placeholder="87"
                                  formControlName="number"
                                  (input)="handleValidatePhone('mobile')"
                                />
                                <input
                                  type="text"
                                  class="form-control width-70"
                                  [appOnlyNumber]="false"
                                  [keepSignAndZero]="true"
                                  placeholder="123-4567"
                                  formControlName="extension"
                                  (input)="handleValidatePhone('mobile')"
                                />
                              </div>
                              <div
                                *ngIf="addForm.get('phoneNumbers.mobile.countryCode')?.hasError('invalidPhoneNumber')"
                                class="error-msg"
                              >
                                <label for="" class="error">
                                  <img alt="" src="assets/images/icon/error.png" class="error-icon" />
                                  Invalid phone number.
                                </label>
                              </div>
                            </div>
                          </div>

                          <label
                            *ngIf="addForm.errors?.['mobilePhoneIncomplete']"
                            for=""
                            class="error text-nowrap mt-0"
                          >
                            <img alt="" src="assets/images/icon/error.png" class="error-icon" />
                            Please enter all phone number fields
                          </label>
                        </div>

                        <div class="phone-container width-165 field-groups" formGroupName="home">
                          <div class="mt-1">
                            <label class="form-title text-nowrap">
                              <span *ngIf="showPhoneAsterisk('home')" class="required">*</span>Home Phone
                            </label>
                            <div class="d-flex flex-column">
                              <div class="d-flex align-items-center">
                                <input
                                  type="text"
                                  class="form-control width-45 me-1"
                                  appOnlyNumber
                                  [allowedSign]="'+'"
                                  [keepSignAndZero]="true"
                                  placeholder="+353"
                                  formControlName="countryCode"
                                  (input)="handleValidatePhone('home')"
                                />
                                <input
                                  type="text"
                                  class="form-control width-35 me-1"
                                  appOnlyNumber
                                  [keepSignAndZero]="true"
                                  placeholder="87"
                                  formControlName="number"
                                  (input)="handleValidatePhone('home')"
                                />
                                <input
                                  type="text"
                                  class="form-control width-70"
                                  [appOnlyNumber]="false"
                                  [keepSignAndZero]="true"
                                  placeholder="123-4567"
                                  formControlName="extension"
                                  (input)="handleValidatePhone('home')"
                                />
                              </div>
                              <div
                                *ngIf="addForm.get('phoneNumbers.home.countryCode')?.hasError('invalidPhoneNumber')"
                                class="error-msg"
                              >
                                <label for="" class="error">
                                  <img alt="" src="assets/images/icon/error.png" class="error-icon" />
                                  Invalid phone number.
                                </label>
                              </div>
                            </div>
                          </div>

                          <label *ngIf="addForm.errors?.['homePhoneIncomplete']" for="" class="error text-nowrap mt-0">
                            <img alt="" src="assets/images/icon/error.png" class="error-icon" />
                            Please enter all phone number fields
                          </label>
                        </div>

                        <div class="phone-container width-165 field-groups" formGroupName="office">
                          <div class="mt-1">
                            <label class="form-title text-nowrap">
                              <span *ngIf="showPhoneAsterisk('office')" class="required">*</span>Office Phone
                            </label>
                            <div class="d-flex flex-column">
                              <div class="d-flex align-items-center">
                                <input
                                  type="text"
                                  class="form-control width-45 me-1"
                                  appOnlyNumber
                                  [allowedSign]="'+'"
                                  [keepSignAndZero]="true"
                                  placeholder="+353"
                                  formControlName="countryCode"
                                  (input)="handleValidatePhone('office')"
                                />
                                <input
                                  type="text"
                                  class="form-control width-35 me-1"
                                  appOnlyNumber
                                  [keepSignAndZero]="true"
                                  placeholder="87"
                                  formControlName="number"
                                  (input)="handleValidatePhone('office')"
                                />
                                <input
                                  type="text"
                                  class="form-control width-70"
                                  [appOnlyNumber]="false"
                                  [keepSignAndZero]="true"
                                  placeholder="123-4567"
                                  formControlName="extension"
                                  (input)="handleValidatePhone('office')"
                                />
                              </div>
                              <div
                                *ngIf="addForm.get('phoneNumbers.office.countryCode')?.hasError('invalidPhoneNumber')"
                                class="error-msg"
                              >
                                <label for="" class="error">
                                  <img alt="" src="assets/images/icon/error.png" class="error-icon" />
                                  Invalid phone number.
                                </label>
                              </div>
                            </div>
                          </div>

                          <label
                            *ngIf="addForm.errors?.['officePhoneIncomplete']"
                            for=""
                            class="error text-nowrap mt-0"
                          >
                            <img alt="" src="assets/images/icon/error.png" class="error-icon" />
                            Please enter all phone number fields
                          </label>
                        </div>
                      </ng-container>

                      <div *ngIf="addForm.errors?.['atLeastOnePhoneRequired'] && addForm.touched" class="col-12 mb-1">
                        <label class="error text-nowrap">
                          <img alt="" src="assets/images/icon/error.png" class="error-icon" />
                          At least one phone number is required (Mobile, Home or Office).
                        </label>
                      </div>

                      <div class="width-220 field-groups rs-email">
                        <div class="mt-1">
                          <label for="contactEmail" class="form-title text-nowrap">
                            <span class="required">*</span> Email
                          </label>
                          <input
                            type="text"
                            class="form-control sd-width"
                            placeholder=""
                            formControlName="email"
                            id="contactEmail"
                          />
                        </div>
                        <app-form-error-component [control]="addForm.controls['email']"></app-form-error-component>
                      </div>

                      <div class="width-75 field-groups">
                        <div class="mt-1">
                          <label for="loyalSince" class="form-title text-nowrap"> Loyal Since </label>
                          <div class="input-group">
                            <ng-select
                              class="custom"
                              id="roleId-2"
                              [style.flex]="1"
                              appendTo="div"
                              [items]="years"
                              [virtualScroll]="true"
                              bindLabel="name"
                              bindValue="id"
                              placeholder="All"
                              formControlName="loyalSince"
                            >
                              <ng-template ng-label-tmp let-item="item">
                                {{ item.id }}
                              </ng-template>
                              <ng-template ng-option-tmp let-item="item">
                                <span [title]="item.name" tooltip="item.name">{{ item.name }}</span>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                        <app-form-error-component [control]="addForm.controls['loyalSince']"></app-form-error-component>
                      </div>

                      <div class="field-groups width-125 historic-rs">
                        <div class="mt-1">
                          <label for="totalHistoricValue" class="form-title text-nowrap label-ellipsis tooltip-ng">
                            Total Historic Value
                          </label>
                          <input
                            type="text"
                            [appOnlyNumber]="true"
                            class="form-control sd-width numberText"
                            placeholder=""
                            formControlName="totalHistoricValue"
                            id="totalHistoricValue"
                            (keypress)="preventNegative($event)"
                          />
                        </div>
                        <app-form-error-component
                          [control]="addForm.controls['totalHistoricValue']"
                        ></app-form-error-component>
                      </div>

                      <div class="field-groups width-75">
                        <div class="mt-1">
                          <label
                            for="paymentCycle"
                            class="form-title text-nowrap label-ellipsis tooltip-ng"
                            [ngbTooltip]="tooltipData.paymentCycle"
                            placement="top"
                          >
                            Payment Cycle
                          </label>

                          <input
                            type="number"
                            class="form-control sd-width"
                            placeholder=""
                            formControlName="paymentCycle"
                            id="paymentCycle"
                            (keypress)="preventNegative($event)"
                          />
                        </div>
                        <app-form-error-component
                          [control]="addForm.controls['paymentCycle']"
                        ></app-form-error-component>
                      </div>

                      <div class="width-125 field-groups">
                        <div class="mt-1">
                          <label
                            for="creditNotes"
                            class="form-title text-nowrap label-ellipsis tooltip-ng"
                            [ngbTooltip]="tooltipData.notesIssued"
                            placement="top"
                          >
                            Credit Notes Issued
                          </label>
                          <input
                            type="text"
                            [appOnlyNumber]="true"
                            class="form-control sd-width numberText"
                            placeholder=""
                            formControlName="creditNotes"
                            id="creditNotes"
                            (keypress)="preventNegative($event)"
                          />
                        </div>
                        <app-form-error-component
                          [control]="addForm.controls['creditNotes']"
                        ></app-form-error-component>
                      </div>

                      <div class="width-125 field-groups">
                        <div class="mt-1">
                          <label
                            for="invoicesPredicted"
                            class="form-title text-nowrap label-ellipsis tooltip-ng"
                            [ngbTooltip]="tooltipData.invoices"
                            placement="top"
                          >
                            Invoices Predicted Per Annum
                          </label>
                          <input
                            type="text"
                            [appOnlyNumber]="true"
                            class="form-control sd-width numberText"
                            placeholder=""
                            formControlName="invoicesPredicted"
                            id="invoicesPredicted"
                            (keypress)="preventNegative($event)"
                          />
                        </div>
                        <app-form-error-component
                          [control]="addForm.controls['invoicesPredicted']"
                        ></app-form-error-component>
                      </div>

                      <div class="width-125 mb-2 field-groups">
                        <div class="mt-1">
                          <label
                            for="predictedRevenue"
                            class="form-title text-nowrap label-ellipsis tooltip-ng"
                            [ngbTooltip]="tooltipData.annualRevenue"
                            placement="left"
                          >
                            Predicted Annual Revenue
                          </label>
                          <input
                            type="text"
                            [appOnlyNumber]="true"
                            class="form-control sd-width numberText"
                            placeholder=""
                            formControlName="predictedRevenue"
                            id="predictedRevenue"
                            (keypress)="preventNegative($event)"
                          />
                        </div>
                        <app-form-error-component
                          [control]="addForm.controls['predictedRevenue']"
                        ></app-form-error-component>
                      </div>
                    </ng-container>

                    <!-- Section Primary Address -->
                    <ng-container formArrayName="addresses">
                      <ng-container formGroupName="0">
                        <div class="card dabetors-creditor-card">
                          <div class="card-header">Primary Address</div>
                        </div>

                        <div class="width-180 field-groups">
                          <div class="mt-1">
                            <label for="lineOne" class="form-title text-nowrap">
                              <span class="required">*</span> Address 1
                            </label>
                            <input
                              type="text"
                              class="form-control sd-width"
                              placeholder=""
                              formControlName="lineOne"
                              id="lineOne"
                            />
                          </div>
                          <app-form-error-component
                            [control]="getAddressControl(0, 'lineOne')"
                          ></app-form-error-component>
                        </div>
                        <div class="width-180 field-groups">
                          <div class="mt-1">
                            <label for="lineTwo" class="form-title text-nowrap"> Address 2 </label>
                            <input
                              type="text"
                              class="form-control sd-width"
                              placeholder=""
                              formControlName="lineTwo"
                              id="lineTwo"
                            />
                          </div>
                          <app-form-error-component
                            [control]="getAddressControl(0, 'lineTwo')"
                          ></app-form-error-component>
                        </div>
                        <div class="width-135 field-groups">
                          <div class="mt-1">
                            <label for="city" class="form-title text-nowrap">
                              <span class="required">*</span>City
                            </label>
                            <input
                              type="text"
                              class="form-control sd-width"
                              placeholder=""
                              formControlName="city"
                              id="city"
                            />
                          </div>
                          <app-form-error-component [control]="getAddressControl(0, 'city')"></app-form-error-component>
                        </div>
                        <div class="width-140 field-groups">
                          <div class="mt-1">
                            <label for="state" class="form-title text-nowrap">
                              <span class="required">*</span>State/County
                            </label>
                            <input
                              type="text"
                              class="form-control sd-width"
                              placeholder=""
                              formControlName="state"
                              id="state"
                            />
                          </div>
                          <app-form-error-component
                            [control]="getAddressControl(0, 'state')"
                          ></app-form-error-component>
                        </div>
                        <div class="width-110 field-groups">
                          <div class="mt-1">
                            <label for="area" class="form-title text-nowrap"> Area </label>
                            <input
                              type="text"
                              class="form-control sd-width"
                              placeholder=""
                              formControlName="area"
                              id="area"
                            />
                          </div>
                          <app-form-error-component [control]="getAddressControl(0, 'area')"></app-form-error-component>
                        </div>
                        <div class="width-110 field-groups">
                          <div class="mt-1">
                            <label for="zipCode" class="form-title text-nowrap">
                              <span class="required">*</span> Post Code
                            </label>
                            <input
                              type="text"
                              class="form-control sd-width"
                              placeholder=""
                              formControlName="zipCode"
                              id="zipCode"
                            />
                          </div>
                          <app-form-error-component
                            [control]="getAddressControl(0, 'zipCode')"
                          ></app-form-error-component>
                        </div>
                        <div class="width-135 field-groups">
                          <div class="mt-1">
                            <label for="primaryCountry" class="form-title text-nowrap">
                              <span class="required">*</span> Country
                            </label>
                            <div class="input-group">
                              <ng-select
                                class="custom"
                                id="roleId-2"
                                [style.flex]="1"
                                appendTo="div"
                                [items]="countryList"
                                [virtualScroll]="true"
                                bindLabel="name"
                                bindValue="id"
                                placeholder="All"
                                formControlName="country"
                                (change)="onCountryChange($event, 0)"
                              >
                              </ng-select>
                            </div>
                          </div>
                          <app-form-error-component
                            [control]="getAddressControl(0, 'country')"
                          ></app-form-error-component>
                        </div>
                      </ng-container>

                      <!-- Section Billing Address  -->
                      <ng-container>
                        <div class="card dabetors-creditor-card">
                          <div class="card-header d-flex text-nowrap">
                            Billing Address
                            <div class="pl-3 form-group checkbox-sec align-items-center">
                              <input
                                type="checkbox"
                                id="address"
                                [(ngModel)]="isSameAsPrimaryAddress"
                                [ngModelOptions]="{ standalone: true }"
                                class="ms-2 address-checkbox"
                                (change)="isPrimaryAddress()"
                                #addressCheckbox
                              />
                              <a
                                href="#"
                                onclick="return false;"
                                class="ms-2 primary-add"
                                (click)="addressCheckbox.click(); $event.preventDefault()"
                                >same as Primary Address</a
                              >
                            </div>
                          </div>
                        </div>
                        <ng-container formGroupName="1">
                          <div class="width-180 field-groups">
                            <div class="mt-1">
                              <label for="billingLineOne" class="form-title text-nowrap">
                                <span class="required">*</span> Address 1
                              </label>
                              <input
                                type="text"
                                class="form-control sd-width"
                                placeholder=""
                                formControlName="lineOne"
                                id="billingLineOne"
                              />
                            </div>
                            <app-form-error-component
                              [control]="getAddressControl(1, 'lineOne')"
                            ></app-form-error-component>
                          </div>
                          <div class="width-180 field-groups">
                            <div class="mt-1">
                              <label for="billingLineTwo" class="form-title text-nowrap"> Address 2 </label>
                              <input
                                type="text"
                                class="form-control sd-width"
                                placeholder=""
                                formControlName="lineTwo"
                                id="billingLineTwo"
                              />
                            </div>
                            <app-form-error-component
                              [control]="getAddressControl(1, 'lineTwo')"
                            ></app-form-error-component>
                          </div>
                          <div class="width-135 field-groups">
                            <div class="mt-1">
                              <label for="billingCity" class="form-title text-nowrap">
                                <span class="required">*</span>City
                              </label>
                              <input
                                type="text"
                                class="form-control sd-width"
                                placeholder=""
                                formControlName="city"
                                id="billingCity"
                              />
                            </div>
                            <app-form-error-component
                              [control]="getAddressControl(1, 'city')"
                            ></app-form-error-component>
                          </div>
                          <div class="width-140 field-groups">
                            <div class="mt-1">
                              <label for="billingState" class="form-title text-nowrap">
                                <span class="required">*</span>State/County
                              </label>
                              <input
                                type="text"
                                class="form-control sd-width"
                                placeholder=""
                                formControlName="state"
                                id="billingState"
                              />
                            </div>
                            <app-form-error-component
                              [control]="getAddressControl(1, 'state')"
                            ></app-form-error-component>
                          </div>
                          <div class="width-110 field-groups">
                            <div class="mt-1">
                              <label for="billingArea" class="form-title text-nowrap">Area </label>
                              <input
                                type="text"
                                class="form-control sd-width"
                                placeholder=""
                                formControlName="area"
                                id="billingArea"
                              />
                            </div>
                            <app-form-error-component
                              [control]="getAddressControl(1, 'area')"
                            ></app-form-error-component>
                          </div>
                          <div class="width-110 field-groups">
                            <div class="mt-1">
                              <label for="billingZipCode" class="form-title text-nowrap">
                                <span class="required">*</span> Post Code
                              </label>
                              <input
                                type="text"
                                class="form-control sd-width"
                                placeholder=""
                                formControlName="zipCode"
                                id="billingZipCode"
                              />
                            </div>
                            <app-form-error-component
                              [control]="getAddressControl(1, 'zipCode')"
                            ></app-form-error-component>
                          </div>
                          <div class="width-135 field-groups">
                            <div class="mt-1">
                              <label for="billingCountry" class="form-title text-nowrap">
                                <span class="required">*</span> Country
                              </label>
                              <div class="input-group">
                                <ng-select
                                  class="custom"
                                  id="roleId-2"
                                  [style.flex]="1"
                                  appendTo="div"
                                  [items]="countryList"
                                  [virtualScroll]="true"
                                  bindLabel="name"
                                  bindValue="id"
                                  placeholder="All"
                                  formControlName="country"
                                  (change)="onCountryChange($event, 1)"
                                >
                                </ng-select>
                              </div>
                            </div>
                            <app-form-error-component
                              [control]="getAddressControl(1, 'country')"
                            ></app-form-error-component>
                          </div>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                    <!-- Section Experience -->
                    <ng-container>
                      <div class="card dabetors-creditor-card">
                        <div class="card-header">Experience</div>
                      </div>

                      <div class="col-12 mt-1 mb-1 form-group file-upload d-flex">
                        <label for="image_file" class="me-2 mt-1">Experience File: </label>
                        <input type="file" id="image_file" #fileUploader (change)="fileChange($event)" accept=".xlsx" />

                        <div class="loader_gif" *ngIf="showUploadLoader">
                          <img alt="" width="20px" src="assets/images/icon/loader-1.gif" />
                        </div>

                        <img
                          *ngIf="isSelected && !showUploadLoader"
                          class="ms-1 cursor-pointer"
                          src="assets/images/icon/cross-icon.svg"
                          (click)="clearFileInput(fileUploader)"
                          alt=""
                          width="10px"
                        />
                      </div>
                      <div class="col-12 mt-1 mb-1 form-group file-upload">
                        <a target="_blank" class="download-link-a d-block" (click)="downloadTemplate()">
                          Download XLSX Template
                        </a>
                      </div>
                    </ng-container>
                  </div>

                  <div class="col-12 bottom-fixed mt-3">
                    <div class="d-flex justify-content-center">
                      <button
                        [disabled]="addForm.invalid"
                        type="submit"
                        class="btn btn-light me-3 btn-custom-footer save_btn"
                      >
                        Save
                      </button>
                      <button
                        type="button"
                        class="btn btn-light btn-custom-footer cancel_btn"
                        data-dismiss="modal"
                        (click)="closeModal()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
